export default __webpack_public_path__ + "img/dwuleaXr.b6adcac9.svg";